import { TenantSyncStateEnum } from '@reach/shared-types/tenant-filter';
import { EngageLibrarySyncActionEnum, PendingMembershipChange } from './engage-library-types';
import { engageLibraryRowKey } from './engage-library-utils';
import styles from './EngageLibraryChangeSection.module.css';

const DRAFT_ADDITION_SUFFIX = '(draft — only this tenant)';

interface EngageLibraryChangeGroupProps {
  label: string;
  changes: PendingMembershipChange[];
}

export function EngageLibraryChangeGroup({ label, changes }: EngageLibraryChangeGroupProps) {
  const items = changes.map(change => {
    const isDraft = change.row.tenantSyncState === TenantSyncStateEnum.DRAFT;
    const addsDraft = isDraft && change.action === EngageLibrarySyncActionEnum.SYNC;
    return {
      key: engageLibraryRowKey(change.row),
      label: addsDraft ? `${change.row.name} ${DRAFT_ADDITION_SUFFIX}` : change.row.name,
    };
  });

  return (
    <div className={styles.group}>
      <h4>{label}</h4>
      <ul>
        {items.map(item => (
          <li key={item.key}>{item.label}</li>
        ))}
      </ul>
    </div>
  );
}
